import { useTranslation } from "react-i18next";
import visigalogo from "../assets/visigalogo.png";
import hailmary3 from "../assets/hailmary3.png";

const AboutUs = () => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 px-4 lg:px-10 mt-0 dark:bg-gray-800 bg-white text-black dark:text-white">
      {/* First Column */}
      <div className="lg:col-span-3 bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex flex-col items-center rounded-lg shadow-lg">
        <h1 className="text-3xl sm:text-xl lg:text-2xl text-center font-bold tracking-wide text-gray-900 dark:text-white mb-6">
          {t("schoolName")}{" "}
          <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text block mt-2">
            {t("schoolSub")}
          </span>
        </h1>
        <img
          src={visigalogo}
          alt="Visiga Seminary Logo"
          className="mt-4 w-40 h-auto rounded-full border-4 border-white dark:border-gray-700 shadow-md hover:scale-105 transition-transform duration-300"
        />
      </div>

      {/* Middle Content */}
      <div className="lg:col-span-6 flex flex-col items-center mt-1 lg:mt-5">
        <h2 className="text-2xl text-center underline">{t("about.developmentPlan")}</h2>

        <h2 className="mt-4 text-2xl text-center">
          {t("about.visionOf")}{" "}
          <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text">
            {t("about.location")}
          </span>
        </h2>
        <p className="mt-4 text-lg text-center italic">{t("about.vision")}</p>
        <p className="text-center italic">{t("about.visionVerse")}</p>

        <h2 className="mt-4 text-2xl text-center">
          {t("about.missionOf")}{" "}
          <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text">
            {t("about.location")}
          </span>
        </h2>
        <p className="mt-2 text-lg text-center">{t("about.mission")}</p>

        <h2 className="mt-4 text-2xl text-center">{t("about.achievementsGoalsTitle")}</h2>
        <p className="mt-2 text-lg text-center">{t("about.achievementsGoals")}</p>

        <h2 className="mt-4 text-2xl text-center">{t("about.mottoTitle")}</h2>
        <div className="mt-2 text-center">
          <p className="font-bold">{t("about.mottoBold")}</p>
          <p>{t("about.mottoExplanation")}</p>
        </div>
        <div className="mt-2 text-center">
          <p>___________________</p>
        </div>
      </div>

      {/* Right Column */}
      <div className="lg:col-span-3 bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex flex-col items-center rounded-lg shadow-lg">
        <img
          src={hailmary3}
          alt="Hail Mary"
          className="w-full h-auto max-h-96 object-cover rounded-lg border-4 border-white dark:border-gray-700 shadow-md hover:scale-102 transition-transform duration-300"
        />
        <p className="mt-4 text-center text-gray-600 dark:text-gray-300 italic">
          {t("motherText")}
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
